/* eslint no-console:0 */
/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// console.log('Hello World from Webpacker');
// Support component names relative to this directory:
// const componentRequireContext = require.context('teacher/components', true);
// const ReactRailsUJS = require('react_ujs');

// ReactRailsUJS.useContext(componentRequireContext);

import { mountComponents } from '../lib/react_rails_mounter';

mountComponents({
  WeeklyDashboard: require('../teacher/components/WeeklyDashboard/WeeklyDashboard'),
  WeeklyDashboard_B: require('../teacher/components/WeeklyDashboard_B/WeeklyDashboard_B'),
  YearlyDashboard: require('../teacher/components/YearlyDashboard/Yearly'),
  CurriculumDashboard: require('../teacher/curriculum/index'),
  ActivityStreamDashboard: require('../teacher/components/ActivityStreamDashboard/ActivityStreamDashboard'),
  GetStarted: require('../teacher/components/GetStarted/GetStarted'),
  ParentReport: require('../teacher/components/Parent/Parent'),
  SkillsDashboard: require('../teacher/components/SkillsDashboard'),
  ManageCurriculum: require('../teacher/components/ManageCurriculum/ManageCurriculum'),
  Printables: require('../teacher/components/Printables'),
  Assignments: require('../teacher/components/Assignments'),
  EmptyClass: require('../teacher/components/EmptyClass/EmptyClass'),
  Marathons: require('../teacher/components/Marathons/Marathons'),
  LeaderBoard: require('../teacher/components/Marathons/LeaderBoard'),
  LeaderBoardInfo: require('../teacher/components/Marathons/banner/LeaderBoardInfo'),
  Roster: require('../teacher/components/Roster/Roster'),
});
